import { useAuthContext } from '@archre2/react-core';

const check = (perform, permissions) => {
  if (!permissions || permissions.length === 0) {
    //permissions are not given in id token or not yet loaded
    return false;
  }
  if (permissions.includes(perform)) {
    return true;
  }
  return false;
};

// React 19 Migration: Using default parameters instead of defaultProps
const Can = ({ perform, yes = () => null, no = () => null }) => {
  const { session } = useAuthContext();
  return check(perform, session.userPermissions) ? yes() : no();
};

export default Can;
